import React, {useState, useEffect, useContext} from "react";
import { Link, useHistory } from "react-router-dom";
import logo from "../../assets/images/logo.svg";
import searchico from "../../assets/images/icon-search.png";
import Navbar from "react-bootstrap/Navbar";
import Dropdown from "react-bootstrap/Dropdown";
import Modal from "react-bootstrap/Modal";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import {CartContext} from "../../contexts/cartContext";
var slugify = require("slugify");

var Scroll = require("react-scroll");
var scroller = Scroll.scroller;

function MobileHeader({ apiLoading, homepageData }) {
  const [productClicked, setProductClicked] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const history = useHistory();
  const [show, setShow] = useState(false);
  const navMenuData = homepageData?.NavMenu

  const { customerCart, setCustomerCart, cartItemCount } = useContext(CartContext)

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  console.log(homepageData);

  useEffect(() => {
    if (productClicked) {
      scroller.scrollTo("HomePageProducts", {
        duration: 800,
        delay: 50,
        smooth: true,
        offset: 0,
      });
      setProductClicked(false);
    }
  }, [setProductClicked, productClicked]);

  const handleSearchTerm = (e: any) => {
    setSearchTerm(e.target.value);
  };

  const clearSearchTerm = (e: any) => {
    setSearchTerm("");
    e.stopPropagation();
  };

  const onSearchSubmit = (e: any) => {
    if(e.keyCode == 13) {
      e.preventDefault(e);
      history.push(`/search/${slugify(searchTerm)}`);
      setSearchTerm("");
      handleClose();
      closeNav();
    }
  };

  const onSearchSubmitButton = (e: any) => {
      e.preventDefault(e);
      history.push(`/search/${slugify(searchTerm)}`);
      setSearchTerm("");
      handleClose();
      closeNav();
  };

  return (
    <header>
      <div className="upper-container">
        <div className="container">
        <div className="top-of-nav">{homepageData?.ContactNumber}</div>
        </div>
      </div>
      <div className="container">
        <Navbar className="navbar" expand="lg">
          <Link className="navbar-brand" to="/">
            <img src={homepageData?.SiteLogo?.url} alt="" />
          </Link>
          <button
            className="navbar-toggler collapsed"
            aria-controls="basic-navbar-nav"
            onClick={openNav}
          >
            <span className="navbar-toggler-icon"></span>
            <span className="navbar-toggler-icon"></span>
            <span className="navbar-toggler-icon"></span>
          </button>

          <Navbar.Collapse className="overlay" id="myNav">
            <a
              href="javascript:void(0)"
              className="closebtn"
              onClick={closeNav}
            >
              &times;
            </a>
            <ul className="overlay-content navbar-nav ml-auto">
              {homepageData?.NavMenu?.map((menu, id) => ( GetMenuObject(menu, id, setProductClicked, navMenuData)))}
              <li className="nav-item">
                <Dropdown className="nav-link">
                  <Dropdown.Toggle
                    className="noCaret"
                    style={{ cursor: "pointer" }}
                    as="div"
                    id="dropdown-basic"
                    onClick={handleShow}
                  >
                    <img src={searchico} alt="" />
                  </Dropdown.Toggle>
                </Dropdown>
              </li>
              <li className="nav-item" style={{position: 'relative', marginLeft: '-3px'}}>
                <Link to="/cart" className="nav-link" onClick={closeNav}><span style={{fontSize: "19px", width: "25px !important", color: "#ffffff", cursor: "pointer"}} className="material-icons-outlined">local_mall</span></Link><div className="customer-cart-icon">{cartItemCount() > 0 && cartItemCount()}</div>
              </li>
            </ul>
          </Navbar.Collapse>
        </Navbar>
      </div>

      <Modal show={show} onHide={handleClose} dialogClassName="modal-custom">
        <div>
          <a className="close-search" onClick={handleClose}>
            &times;
          </a>
          <div className="search-input-container">
            <textarea id="search-input" placeholder="Search Flooring and Pro-Shop" onChange={handleSearchTerm} onKeyDown={onSearchSubmit}></textarea>
            <button id="search-button" onClick={onSearchSubmitButton} className="btn btn-primary">Search</button>
          </div>
        </div>
      </Modal>
    </header>
  );
}

function GetMenuObject(instance: any, id: any, productCallback: any, navMenuData: any){
  let linkPath = '';
  let menuTitle = '';
  let isExternal = false;

  if(instance.linkType === 'Prebuilt') {
    switch (instance.builtInPage){
      case 'About':
        linkPath = '/about';
        break;
      case 'Distributors':
        linkPath = '/distributors';
        break;
      case 'Gallery':
        linkPath = '/gallery';
        break;
      case 'GallerySecondary':
        linkPath = '/gallery-other';
        break;
      case 'Contact':
        linkPath = '/contact';
        break;
      case 'ProShop':
        linkPath = '/pro-shop';
        break;
      case 'Products':
        if (instance.ParentChild !== "Child") {
          return (
            <li className="nav-item" key={id}>
              <Link className="nav-link" to="/" onClick={() => scrollToProducts()}>{instance.menuTitle}</Link>
            </li>
          )
        }
        break;
      default:
        linkPath = '';
        menuTitle = '';
        break;
    }
  }
  else if(instance.linkType === 'CustomPage'){
    linkPath = `/page/${instance.custom_page?.slug}`;
  }
  else if(instance.linkType === 'External'){
    linkPath = instance.externalLink;
    isExternal = true
  }
  else if(instance.linkType === 'Product'){
    linkPath = `/pro-shop/product-category/${instance.product?.product_category?.Slug}/${instance.product?.Slug}`;
  }
  menuTitle = instance.menuTitle;
  if (menuTitle && instance.ParentChild === "Parent"){
    return(
        <li className="nav-item">
          <Dropdown className="nav-link">
            <Dropdown.Toggle style={{cursor: "pointer"}} as="div" id="dropdown-basic">
              {menuTitle}
            </Dropdown.Toggle>

            <Dropdown.Menu className="" id="menu-dropdown">
              {navMenuData?.filter(title => title.custom_dropdown?.DropdownTitle.includes(instance.custom_dropdown?.DropdownTitle)).map((item, index) =>
                  <>
                    {index !== 0 &&
                    childLinkPath(item)
                    }
                  </>
              )}
            </Dropdown.Menu>
          </Dropdown>
        </li>
    )
  }
  if(menuTitle && linkPath && instance.ParentChild !== "Child"){

    if (isExternal) {
      return (
        <li className="nav-item" key={id}>
          <a className='nav-link' onClick={() => closeNav()} href={linkPath}>{menuTitle}</a>
        </li>
      )
    } else {
      return (
        <li className="nav-item" key={id}>
          <Link className='nav-link' onClick={() => closeNav()} to={linkPath}>{menuTitle}</Link>
        </li>
      )
    }
  }
}

function childLinkPath(instance) {
  let linkPath
  if(instance.linkType === 'Prebuilt') {
    switch (instance.builtInPage){
      case 'About':
        linkPath = '/about';
        break;
      case 'Distributors':
        linkPath = '/distributors';
        break;
      case 'Gallery':
        linkPath = '/gallery';
        break;
      case 'GallerySecondary':
        linkPath = '/gallery-other';
        break;
      case 'Products':
        if (instance.ParentChild === "Child") {
          return(
              <Dropdown.Item as="form">
                <Link className="nav-link" to="/" onClick={() => {scrollToProducts(); closeNav()}}>{instance.menuTitle}</Link>
              </Dropdown.Item>)
        }
        break;
      default:
        linkPath = '';
        break;
    }
  }
  else if(instance.linkType === 'CustomPage'){
    linkPath = `/page/${instance.custom_page?.slug}`;
  }
  else if(instance.linkType === 'Product'){
    linkPath = `/pro-shop/product-category/${instance.product?.product_category?.Slug}/${instance.product?.Slug}`;
  }
  else if(instance.linkType === 'External'){
    linkPath = instance.externalLink;
    return(
        <Dropdown.Item as="form">
          <a className='nav-link' href={linkPath} onClick={() => closeNav()}>{instance.menuTitle}</a>
        </Dropdown.Item>
    )
  }
  return(
      <Dropdown.Item as="form">
        <Link className='nav-link' to={linkPath} onClick={() => closeNav()}>{instance.menuTitle}</Link>
      </Dropdown.Item>
  )
}

function openNav() {
  document!.getElementById("myNav")!.style.height = "100%";
}

function closeNav() {
  document!.getElementById("myNav")!.style.height = "0%";
}

const scrollToProducts = () => {
  localStorage.setItem('scroll-loc', 'HomePageProducts');
}

MobileHeader.propTypes = {
  apiLoading: PropTypes.bool,
  homepageData: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  apiLoading: state.apiReducer.apiLoading,
  homepageData: state.apiReducer.homepageData,
});

export default connect(mapStateToProps)(MobileHeader);
